import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tailwind.css';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';

// Suppress Quill's DOMNodeInserted & findDOMNode warnings
const originalError = console.error;
console.error = (...args) => {
  if (/DOMNodeInserted/.test(args[0]) || /findDOMNode is deprecated/.test(args[0])) {
    return;
  }
  originalError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
